import { createElementBlock as C, openBlock as l, createElementVNode as n } from "vue";
const o = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-eye"
};
function t(r, e) {
  return l(), C("svg", o, e[0] || (e[0] = [
    n("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.43443 10.9832C6.48751 12.7833 5.20898 14.8165 4.69717 15.7112C4.67 15.7587 4.67 15.8025 4.69717 15.8499C5.20898 16.7447 6.48751 18.7779 8.43443 20.578C10.3825 22.3791 12.9296 23.8845 16.0001 23.8845C19.0707 23.8845 21.6178 22.3791 23.5658 20.578C25.5127 18.7779 26.7913 16.7447 27.3031 15.8499C27.3302 15.8025 27.3302 15.7587 27.3031 15.7112C26.7913 14.8165 25.5127 12.7833 23.5658 10.9832C21.6178 9.18202 19.0707 7.67667 16.0001 7.67667C12.9296 7.67667 10.3825 9.18202 8.43443 10.9832ZM7.29618 9.75207C9.41729 7.79093 12.3524 6 16.0001 6C19.6479 6 22.583 7.79093 24.7041 9.75207C26.8263 11.7143 28.204 13.9094 28.7585 14.8787C29.0807 15.442 29.0807 16.1192 28.7585 16.6825C28.204 17.6518 26.8263 19.8469 24.7041 21.8091C22.583 23.7702 19.6479 25.5611 16.0001 25.5611C12.3524 25.5611 9.41729 23.7702 7.29618 21.8091C5.17392 19.8469 3.79627 17.6518 3.24179 16.6825C2.91957 16.1192 2.91957 15.442 3.24179 14.8787C3.79627 13.9094 5.17392 11.7143 7.29618 9.75207ZM15.9997 19.6927C18.1604 19.6927 19.912 17.9412 19.912 15.7805C19.912 13.6198 18.1604 11.8683 15.9997 11.8683C13.8391 11.8683 12.0875 13.6198 12.0875 15.7805C12.0875 17.9412 13.8391 19.6927 15.9997 19.6927ZM21.5886 15.7805C21.5886 18.8672 19.0864 21.3694 15.9997 21.3694C12.9131 21.3694 10.4109 18.8672 10.4109 15.7805C10.4109 12.6938 12.9131 10.1916 15.9997 10.1916C19.0864 10.1916 21.5886 12.6938 21.5886 15.7805Z",
      fill: "#0B6AB7",
      class: "svg__fill--primary-blue-03"
    }, null, -1)
  ]));
}
const s = { render: t };
export {
  s as default,
  t as render
};
